<template>
  <v-container fluid>

    <v-row justify="end">
      <v-col cols="6" md="3" class="py-0">
        <mp-button min wide @click="goCopy">複製</mp-button>
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-col cols="12">
        <h1>{{$t("message.admin.sendmail.title.detail")}}</h1>
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-col cols="12" class="pt-0">
        <h2>{{$t("message.admin.sendmail.subtitle.mail")}}</h2>
      </v-col>
    </v-row>

    <v-row justify="center" dense>
      <v-col cols="4">
        <mp-label>{{$t("message.admin.sendmail.label.sendDate")}}</mp-label>
      </v-col>
      <v-col cols="8">
        <mp-input-box>{{ view.detail.sendEndDt | dateFormatter }}</mp-input-box>
      </v-col>
    </v-row>

    <v-row justify="center" dense>
      <v-col cols="4">
        <mp-label>{{$t("message.admin.sendmail.label.register")}}</mp-label>
      </v-col>
      <v-col cols="8">
        <mp-input-box>{{ view.detail.register }}</mp-input-box>
      </v-col>
    </v-row>

    <v-row justify="center" dense>
      <v-col cols="4">
        <mp-label>{{$t("message.admin.sendmail.label.from")}}</mp-label>
      </v-col>
      <v-col cols="8">
        <mp-input-box>{{ view.detail.frm }}</mp-input-box>
      </v-col>
    </v-row>

    <v-row justify="center" dense>
      <v-col cols="4">
        <mp-label>{{$t("message.admin.sendmail.label.cc")}}</mp-label>
      </v-col>
      <v-col cols="8">
        <mp-input-box>{{ view.detail.cc }}</mp-input-box>
      </v-col>
    </v-row>

    <v-row justify="center" dense>
      <v-col cols="4">
        <mp-label>{{$t("message.admin.sendmail.label.subject")}}</mp-label>
      </v-col>
      <v-col cols="8">
        <mp-input-box>{{ view.detail.subject }}</mp-input-box>
      </v-col>
    </v-row>

    <v-row justify="center" dense>
      <v-col cols="4">
        <mp-label>{{$t("message.admin.sendmail.label.body")}}</mp-label>
      </v-col>
      <v-col cols="8" class="pr-0">
        <mp-multiple-lines-input-box style="height: 30vh; min-height: 30px;">{{ view.detail.body }}</mp-multiple-lines-input-box>
      </v-col>
    </v-row>

    <!-- 埋め込み文字列説明 -->
    <v-row justify="center" v-if="isIncludesEmbeddedString">
      <v-col cols="4" class="pt-0"></v-col>
      <v-col class="explain-text pt-0">
        <div>{{$t('message.admin.sendmail.desc.send.text1')}}</div>
        <div>{{ $t('message.admin.sendmail.desc.send.text2') }}</div>
      </v-col>
    </v-row>

    <v-row justify="center" style="margin-top: 2vh;">
      <v-col cols="12" class="pt-0">
        <h2>{{$t("message.admin.sendmail.subtitle.sendList")}}</h2>
      </v-col>
    </v-row>

    <!-- 宛先条件 -->
    <v-row justify="center" dense>
      <v-col cols="2" class="pb-0">
        <mp-label class="pt-0"></mp-label>
      </v-col>
      <v-col cols="2">
        <mp-label>{{$t("message.admin.sendmail.label.services")}}</mp-label>
      </v-col>
      <v-col cols="8">
        <mp-input-box >{{ view.detail.services }}</mp-input-box>
      </v-col>
    </v-row>

    <v-row justify="center" dense>
      <v-col cols="2" class="py-0">
        <mp-label class="pt-0">{{$t("message.admin.sendmail.label.sendCondition")}}</mp-label>
      </v-col>
      <v-col cols="2">
        <mp-label>{{$t("message.admin.sendmail.label.group")}}</mp-label>
      </v-col>
      <v-col cols="8">
        <mp-input-box>{{ view.detail.groupLargeNames }}<span v-if="view.detail.groupSmallNames">＞</span>{{ view.detail.groupSmallNames }}</mp-input-box>
      </v-col>
    </v-row>

    <v-row justify="center" dense>
      <v-col cols="2" class="py-0">
        <mp-label class="pt-0"></mp-label>
      </v-col>
      <v-col cols="2">
        <mp-label>{{view.companyLabel.ja}}</mp-label>
      </v-col>
      <v-col cols="8">
        <mp-input-box>{{ view.detail.companies }}</mp-input-box>
      </v-col>
    </v-row>

    <v-row justify="center" dense>
      <v-col cols="2" class="pt-0">
        <mp-label class="pt-0"></mp-label>
      </v-col>
      <v-col cols="2">
        <mp-label>{{$t("message.admin.sendmail.label.prefCd")}}</mp-label>
      </v-col>
      <v-col cols="8">
        <mp-input-box>{{ view.detail.prefectures }}</mp-input-box>
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-col cols="12" class="pt-2 py-0 pt-md-0">
          <div class="text-right ma-0 py-0 list-count">{{$t("message.admin.sendmail.desc.list.listCount1")}}：{{ view.list.length | addComma  }}{{$t("message.admin.sendmail.desc.list.listCount2")}}</div>
      </v-col>
    </v-row>

    <!-- 宛先一覧 -->
    <v-row justify="center">
      <v-col cols="12">
        <v-data-table
          item-key="account_id"
          :headers="headers"
          hide-default-header
          :items="view.list"
          locale="jp"
          :loading-text="$t('message.admin.sendmail.desc.list.loading')"
          :no-data-text="$t('message.admin.sendmail.desc.detail.noData')"
          hide-default-footer
          mobile-breakpoint=0
          class="elevation-1"
          disable-pagination
        >
          <template v-slot:[`item.groupName`]="{ item }">
            {{ item.groupLargeNameJp }}<span v-if="item.groupSmallNameJp">＞</span>{{ item.groupSmallNameJp }}
          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <v-row justify="center" v-if="view.list.length > 0">
      <v-col cols="12">
        <div>{{$t("message.admin.sendmail.desc.detail.text2")}}</div>
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-col class="text-center" cols="2">
        <mp-button wide @click="goList">{{$t("message.admin.sendmail.button.back")}}</mp-button>
      </v-col>
    </v-row>

  </v-container>
</template>

<script>
import i18n from '@/message'
import MpLabel from '@/components/item/MpLabel.vue'
import MpInputBox from '@/components/item/MpInputBox.vue'
import MpButton from '@/components/item/MpButton.vue'
import { AdminSendMail, Common } from '@/api'
import StringUtils from '@/utils/StringUtil'
import MpMultipleLinesInputBox from '@/components/item/MpMultipleLinesInputBox.vue'

export default {
  name: 'AdminSendmailDetail',
  components: {
    MpLabel,
    MpInputBox,
    MpButton,
    MpMultipleLinesInputBox
  },
  data: () => ({
    form: {
      mailSendId: ''
    },
    view: {
      companyDefaultLabel: {
        ja: ''
      },
      companyLabel: {
        ja: ''
      },
      groupList: [],
      detail: [],
      list: []
    }
  }),
  computed: {
    headers () {
      return [
        { text: i18n.t('message.admin.sendmail.label.list.group'), value: 'groupName', sortable: false, width: 300 },
        { text: this.view.companyLabel.ja, value: 'companyName', sortable: false, width: 300 },
        { text: i18n.t('message.admin.sendmail.label.list.mailAddress'), value: 'mailAddress', sortable: false },
        { text: i18n.t('message.admin.sendmail.label.list.name'), value: 'name', sortable: false, width: 300 }
      ]
    },
    isIncludesEmbeddedString () {
      if (this.view.detail.body && this.view.detail.body.match(/{{(COMPANY|NAME)}}/)) {
        return true
      } else {
        return false
      }
    }
  },
  methods: {
    goList () {
      // 一覧画面に戻る
      this.$router.push({ path: '/admin/sendmail/history' })
    },
    async getDetail () {
      // パラメータからメール送信IDを取得
      this.form.mailSendId = this.$route.params.id
      // メール情報取得
      this.view.detail = await AdminSendMail.historyDetail({ mailSendId: this.form.mailSendId })
      // 宛先一覧取得
      this.view.list = await AdminSendMail.historyTo({ mailSendId: this.form.mailSendId })
    },
    setCompanyLabel (groupSmallIds) {
      const groupSmall = this.view.groupList
        .flatMap(groupLarge => groupLarge.groupSmallList)
        .filter(groupSmall => groupSmallIds.includes(groupSmall.groupSmallId))

      if (groupSmall.length === 0) {
        this.view.companyLabel.ja = this.view.companyDefaultLabel.ja
      } else {
        const res = []
        for (const grpSmall of groupSmall) {
          const lbl = StringUtils.isEmpty(grpSmall.companyLabel.ja) ? this.view.companyDefaultLabel.ja : grpSmall.companyLabel.ja
          if (!res.includes(lbl)) {
            res.push(lbl)
          }
        }
        this.view.companyLabel.ja = res.join(',')
      }
    },
    async setDefaultLabel () {
      const list = await Common.labelList({ key: 'default' })
      this.view.companyLabel.ja = this.view.companyDefaultLabel.ja = this.getDefaultLabelFromList(list, 'label.default.company.ja')
    },
    getDefaultLabelFromList (list, key) {
      const ele = list.find(ele => ele.configKey === key)
      if (ele === undefined || ele.configVal === undefined) {
        return ''
      }
      return ele.configVal
    },
    goCopy () {
      // 複製する
      this.$router.push({ path: '/admin/sendmail', query: { copyFrom: this.form.mailSendId } })
    }
  },
  created: async function () {
    this.view.groupList = await Common.groupList()
    await this.setDefaultLabel()
    await this.getDetail()
    this.setCompanyLabel(this.view.detail.groupSmallIds)
  }
}
</script>

<style scoped>
.v-icon.mdi-new-box {
    color: #E62233;
  }

.explain-text {
  font-size: 0.8em;
  color: gray;
}

.elevation-1 {
  max-height: 60vh;
  overflow-y: auto;
}
</style>
